import React from 'react'
import Svg from '../Svg'
import Logo from '../../assets/img/logo.svg'
import { useMediaQuery } from 'react-responsive'

const Footer = ({ business = {} }) => {
  const { logo } = business

  const phoneNumbers = business?.phone
  const phoneArrayHandler = () => {
    if (phoneNumbers && typeof phoneNumbers === 'string' && phoneNumbers.includes(',')) {
      return phoneNumbers.split(',').map(phone => phone.trim())
    }
    return []
  }

  const phoneArray = phoneArrayHandler()
  const logoSrc = logo || Logo

  const isMobile = useMediaQuery({ maxWidth: 921 })

  return (
    <footer className='footer-bk-color'>
      <div className="second-footer">
        <div className="container">
          <div className="d-flex">
            {phoneArray?.length > 0 ? (
              <div className='footer-des'>
                <div className="logo-container">
                  <a href="https://bimeh.com/">
                    <img width="180" height="25" src={logoSrc} className="image__logo" alt="بیمه دات کام" />
                  </a>
                </div>
                <div className="info-phone-container mt-1">
                  <div className='rapperDivPhoneNumberText'>
                    <div className='footer-txt-style'>
                      <p className='footer-txt'>هفت روز هفته، ۲۴ ساعته پاسخگوی شما هستیم</p>
                    </div>
                    <div className='footer-phone-style'>
                      <div className='holdPhones'>
                        {isMobile ? <span className="phone-separator-first">|</span> : null}
                        <Svg name="secondFooter-phone" />
                        <div className='surface-color phone-container'>
                          <div className="phone-row">
                            {phoneArray.map((phone, index) => (
                              <React.Fragment key={index}>
                                <a href={`tel:${phone}`} className="phone-number">
                                  {phone}
                                </a>
                                {index < phoneArray.length - 1 && (
                                  <span className="phone-separator">|</span>
                                )}
                              </React.Fragment>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="col">
                <div className="logo-container">
                  <a href="https://bimeh.com/">
                    <img width="180" height="25" src={logoSrc} className="image__logo" alt="بیمه دات کام" />
                  </a>
                </div>
                <div className="info-phone-container">
                  <p>هفت روز هفته، ۲۴ ساعته پاسخگوی شما هستیم</p>
                  {business?.phone && (
                    <a href={`tel:${business.phone}`}>
                      <Svg name="secondFooter-phone" />
                      <span>{business?.phone}</span>
                    </a>
                  )}
                </div>
              </div>
            )}
            <div className="col">
              <div className="social-bullets">
                <a href="https://www.aparat.com/bimehdatcom" aria-label="آپارات" target="_blank" rel="noreferrer nofollow noopener">
                  <Svg name="aparat-footer" />
                </a>
                <a href="https://www.instagram.com/bimehdotcom/" aria-label="اینستاگرام" target="_blank" rel="noreferrer nofollow noopener">
                  <Svg name="instagram-footer" />
                </a>
                <a href="https://linkedin.com/company/bimehdotcom" aria-label="لینکدین" target="_blank" rel="noreferrer nofollow noopener">
                  <Svg name="linkedin-footer" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
